import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import UserRoutes from './components/templates/auth';
import EmsRoutes from './components/templates/ems-auth';

const Routes = () => (
    <Router history={history}>
        <Switch>
          <Route path="/ems/*" component={EmsRoutes} />
          <Route path="*" component={UserRoutes} />
        </Switch>
    </Router>
);

export default Routes;
